export default (theme) => ({
    container: theme.softpro.safeBox,
});
